export default __webpack_public_path__ + "static/media/rocket_anim_98.46946bda.png";